import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@mui/material/SvgIcon';

const wrapSvgPath = (path, viewBox = '0 0 548 118') => {
  return function SvgPathIcon(props) {
    return (
      <SvgIcon {...props} viewBox={viewBox}>
        {path}
      </SvgIcon>
    );
  };
};

const logoPath = (
  <>
    <path
      d="M0.0800781 86.9901V44.4201C0.0800781 41.6701 1.17008 39.0401 3.11008 37.0901L38.0101 2.19011C39.9501 0.250107 43.1001 0.250107 45.0401 2.19011L72.6301 29.7801L42.7401 59.6701C41.9601 60.4501 41.5301 61.5001 41.5301 62.6001V86.9701C41.5301 89.7201 39.3001 91.9401 36.5601 91.9401H5.06008C2.30008 91.9601 0.0800781 89.7301 0.0800781 86.9901Z"
      fill="#29434E"
    />
    <path
      d="M145.18 86.9901V44.4201C145.18 41.6701 144.09 39.0401 142.15 37.0901L107.25 2.19011C105.31 0.250107 102.16 0.250107 100.22 2.19011L72.6299 29.7801L102.52 59.6701C103.3 60.4501 103.73 61.5001 103.73 62.6001V86.9701C103.73 89.7201 105.96 91.9401 108.7 91.9401H140.2C142.96 91.9601 145.18 89.7301 145.18 86.9901Z"
      fill="#29434E"
    />
    <path
      d="M241.9 15.9702V92.0602H228.43V36.1502L208.96 65.0602H202.08L182.8 36.3502V92.0702H169.33V15.9702H184.64L205.66 47.4902L226.68 15.9702H241.9Z"
      fill="#29434E"
    />
    <path
      d="M303.7 35.9402L280.94 101C279.45 105.28 277.89 108.58 276.24 110.89C274.59 113.2 272.66 114.84 270.43 115.81C268.2 116.78 265.38 117.27 261.95 117.27C259.17 117.27 256.65 116.9 254.39 116.17V104.42C256 104.89 257.88 105.12 260.01 105.12C262.46 105.12 264.38 104.53 265.77 103.36C267.16 102.19 268.47 99.9302 269.69 96.5802L271.34 92.0602L251.87 35.9402H265.24L277.64 73.8902L291.01 35.9402H303.7V35.9402Z"
      fill="#29434E"
    />
    <path
      d="M327.63 28.1102V49.4002H355.92V61.5502H327.63V92.0702H314.16V15.9702H360.76V28.1202H327.63V28.1102Z"
      fill="#29434E"
    />
    <path
      d="M381.01 89.8501C376.81 87.2401 373.66 83.6801 371.56 79.1601C369.46 74.6401 368.41 69.5701 368.41 63.9501C368.41 58.4001 369.46 53.3801 371.56 48.8901C373.66 44.4101 376.81 40.8601 381.01 38.2501C385.21 35.6401 390.31 34.3301 396.32 34.3301C402.26 34.3301 407.32 35.6401 411.48 38.2501C415.65 40.8601 418.78 44.4101 420.88 48.8901C422.98 53.3701 424.03 58.3901 424.03 63.9501C424.03 69.5701 422.98 74.6401 420.88 79.1601C418.78 83.6801 415.65 87.2401 411.48 89.8501C407.31 92.4601 402.26 93.7701 396.32 93.7701C390.31 93.7701 385.21 92.4601 381.01 89.8501ZM406.88 77.1501C409.33 73.9001 410.56 69.5001 410.56 63.9501C410.56 58.4001 409.33 54.0101 406.88 50.8001C404.42 47.5901 400.91 45.9801 396.32 45.9801C391.67 45.9801 388.1 47.5901 385.62 50.8001C383.13 54.0101 381.89 58.4001 381.89 63.9501C381.89 69.5101 383.13 73.9101 385.62 77.1501C388.11 80.4001 391.67 82.0201 396.32 82.0201C400.9 82.0201 404.42 80.4001 406.88 77.1501Z"
      fill="#29434E"
    />
    <path
      d="M438.94 89.9001C436.48 87.5901 435.26 84.0301 435.26 79.2101V7.13013H448.24V74.7901C448.24 77.2001 448.63 78.8701 449.4 79.8101C450.18 80.7501 451.56 81.2201 453.57 81.2201C455.57 81.2201 457.35 81.0201 458.9 80.6201V92.2701C455.86 93.0101 453.09 93.3701 450.57 93.3701C445.27 93.3701 441.39 92.2101 438.94 89.9001Z"
      fill="#29434E"
    />
    <path
      d="M468.1 11.05H481.08V26.21H468.1V11.05ZM468.1 35.9401H481.08V92.06H468.1V35.9401Z"
      fill="#29434E"
    />
    <path
      d="M504.91 89.8501C500.71 87.2401 497.56 83.6801 495.46 79.1601C493.36 74.6401 492.31 69.5701 492.31 63.9501C492.31 58.4001 493.36 53.3801 495.46 48.8901C497.56 44.4101 500.71 40.8601 504.91 38.2501C509.11 35.6401 514.21 34.3301 520.22 34.3301C526.16 34.3301 531.22 35.6401 535.38 38.2501C539.55 40.8601 542.68 44.4101 544.78 48.8901C546.88 53.3701 547.93 58.3901 547.93 63.9501C547.93 69.5701 546.88 74.6401 544.78 79.1601C542.68 83.6801 539.55 87.2401 535.38 89.8501C531.21 92.4601 526.16 93.7701 520.22 93.7701C514.21 93.7701 509.11 92.4601 504.91 89.8501ZM530.78 77.1501C533.23 73.9001 534.46 69.5001 534.46 63.9501C534.46 58.4001 533.23 54.0101 530.78 50.8001C528.32 47.5901 524.81 45.9801 520.22 45.9801C515.57 45.9801 512 47.5901 509.52 50.8001C507.03 54.0101 505.79 58.4001 505.79 63.9501C505.79 69.5101 507.03 73.9101 509.52 77.1501C512.01 80.4001 515.57 82.0201 520.22 82.0201C524.8 82.0201 528.32 80.4001 530.78 77.1501Z"
      fill="#29434E"
    />
  </>
);

const MyFolioLogotype: any = wrapSvgPath(logoPath);

MyFolioLogotype.displayName = 'MyFolioLogotype';

MyFolioLogotype.propTypes = {
  viewBox: PropTypes.string,
  titleAccess: PropTypes.string,
};

export default MyFolioLogotype;

export const logotypeRatio = 548 / 118;
export const logotypeWidthWithHeight = (height) => {
  return height * logotypeRatio;
};
